import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconWarningComponent } from "./med-icon-warning.component";

@NgModule({
  declarations: [
    MedIconWarningComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconWarningComponent,
  ],
})
export class MedIconWarningModule { }
